
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { InventoryAction__get_Key, InventoryAction__ToI18nString, InventoryKindModule_all, InventoryKind__get_Key, InventoryBaseStateModule_all, InventoryStatesDtoModule_usageOf, InventoryStateDefinitionModule_isDefaultState, InventoryActionModule_all, InventoryKind__ToI18nString, InventoryBaseState__get_Key } from "../../../Shared/InventoryStates.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { contains, indexed, empty as empty_1, sortBy, length, map, singleton as singleton_1, ofArray, append } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { safeHash, equals, compareArrays, int32ToString, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { map as map_1, collect, append as append_1, empty, singleton, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Button, TextButton } from "../../../Components/Button.js";
import Arrow_Up_3 from "../../../../public/assets/icons/Arrow_Up_3.svg";
import { map as map_2, defaultArg, unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormModule_current, FormModule_kindsFor, FormModule_isSystem, Msg } from "./Types.js";
import Arrow_Down_3 from "../../../../public/assets/icons/Arrow_Down_3.svg";
import { Badge } from "../../../Components/Badge.js";
import { ColorPicker_colorPicker_BD3CF72 } from "../../../SharedComponents/ReactColorPicker.js";
import { FormState__getValidation } from "../../../Shared/Shared.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ConfirmationDialog, DialogWithClasses } from "../../../Components/Dialog.js";
import { ErrorAlert, InformationAlert } from "../../../Components/Alert.js";
import { Input } from "../../../Components/Input.js";
import { TextArea } from "../../../Components/TextArea.js";
import { Select } from "../../../Components/Select.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";

function componentState(formState) {
    if (formState.IsLoading) {
        return "disabled";
    }
    else {
        return "enabled";
    }
}

function disabledIf(condition, state) {
    if (condition) {
        return "disabled";
    }
    else {
        return state;
    }
}

function baseStateLabel(t, baseState) {
    return t(concat("settings.inventory_states.base_state.", ...InventoryBaseState__get_Key(baseState)));
}

function headerCell(text, extraClasses) {
    return reactElement("th", {
        className: join(" ", append(ofArray(["py-2.5", "px-3", "text-sm", "font-semibold", "text-left", "border-b", "border-border"]), extraClasses)),
        children: text,
    });
}

function cell(testId, children) {
    return reactElement("td", {
        className: join(" ", ["py-2", "px-3", "text-sm", "border-b", "border-border", "align-middle"]),
        "data-test-id": testId,
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function tag(text, testId) {
    return reactElement("span", {
        className: join(" ", ["rounded", "bg-gray-100", "px-2", "py-0.5", "text-xs", "text-gray-600"]),
        "data-test-id": testId,
        children: text,
    });
}

function StateRow(props) {
    let elems_3, elems, Icon, Icon_1, elems_2;
    const t = useTranslation()[0];
    const definition = props.Definition;
    const key = definition.Key;
    const state = componentState(props.FormState);
    return reactElement("tr", createObj(ofArray([["className", join(" ", toList(delay(() => (definition.IsArchived ? singleton("opacity-60") : empty()))))], ["data-test-id", concat("inventory-state-row-", ...key)], (elems_3 = [cell(concat("inventory-state-order-", ...key), singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-1"])], (elems = [createElement(TextButton, (Icon = Arrow_Up_3(), {
        ComponentState: disabledIf(props.IsFirst, state),
        Icon: unwrap(Icon),
        Label: "",
        OnClick: () => {
            props.Dispatch(new Msg(14, [key]));
        },
        TestId: concat("inventory-state-move-up-", ...key),
        Variant: "muted",
    })), createElement(TextButton, (Icon_1 = Arrow_Down_3(), {
        ComponentState: disabledIf(props.IsLast, state),
        Icon: unwrap(Icon_1),
        Label: "",
        OnClick: () => {
            props.Dispatch(new Msg(15, [key]));
        },
        TestId: concat("inventory-state-move-down-", ...key),
        Variant: "muted",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))))), cell(concat("inventory-state-name-", ...key), toList(delay(() => {
        let elems_1;
        return append_1(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "flex-wrap"])], (elems_1 = toList(delay(() => append_1(singleton(createElement(Badge, {
            Color: definition.Color,
            Label: definition.Name,
            TestId: concat("inventory-state-badge-", ...key),
        })), delay(() => append_1(definition.IsSystem ? singleton(tag(t("settings.inventory_states.system"), concat("inventory-state-system-", ...key))) : empty(), delay(() => (definition.IsArchived ? singleton(tag(t("settings.inventory_states.archived"), concat("inventory-state-archived-", ...key))) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => ((definition.Description !== "") ? singleton(reactElement("div", {
            className: join(" ", ["mt-1", "text-xs", "text-gray-500"]),
            children: definition.Description,
        })) : empty())));
    }))), cell(concat("inventory-state-base-state-", ...key), singleton_1(baseStateLabel(t, definition.BaseState))), cell(concat("inventory-state-applies-to-", ...key), singleton_1(join(", ", map((kind) => t(InventoryKind__ToI18nString(kind)), definition.AppliesTo)))), cell(concat("inventory-state-actions-count-", ...key), singleton_1(`${length(definition.AllowedActions)} / ${length(InventoryActionModule_all)}`)), cell(concat("inventory-state-usage-", ...key), singleton_1(int32ToString(props.Usage))), cell(concat("inventory-state-controls-", ...key), singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-3", "justify-end"])], (elems_2 = toList(delay(() => append_1(singleton(createElement(TextButton, {
        ComponentState: state,
        Label: t("general.edit"),
        OnClick: () => {
            props.Dispatch(new Msg(3, [definition]));
        },
        TestId: concat("inventory-state-edit-", ...key),
        Variant: "blueButton",
    })), delay(() => append_1(!InventoryStateDefinitionModule_isDefaultState(definition) ? singleton(createElement(TextButton, {
        ComponentState: state,
        Label: definition.IsArchived ? t("settings.inventory_states.restore") : t("settings.inventory_states.archive"),
        OnClick: () => {
            props.Dispatch(new Msg(17, [key, !definition.IsArchived]));
        },
        TestId: concat("inventory-state-archive-", ...key),
        Variant: "blueButton",
    })) : empty(), delay(() => ((!definition.IsSystem && (props.Usage === 0)) ? singleton(createElement(TextButton, {
        ComponentState: state,
        Label: t("general.delete"),
        OnClick: () => {
            props.Dispatch(new Msg(19, [definition]));
        },
        TestId: concat("inventory-state-delete-", ...key),
        Variant: "redButton",
    })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function statesTable(t, dto, formState, dispatch) {
    let elems_3, elems_1, elems, elems_2;
    const states = sortBy((definition) => [definition.SortOrder, definition.Key], dto.States, {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    });
    const lastIndex = (length(states) - 1) | 0;
    return reactElement("table", createObj(ofArray([["className", join(" ", ["w-full", "border-collapse", "text-left", "bg-white"])], ["data-test-id", "inventory-states-table"], (elems_3 = [reactElement("thead", createObj(singleton_1((elems_1 = [reactElement("tr", createObj(singleton_1((elems = [headerCell(t("settings.inventory_states.header.order"), empty_1()), headerCell(t("settings.inventory_states.header.name"), empty_1()), headerCell(t("settings.inventory_states.header.base_state"), empty_1()), headerCell(t("settings.inventory_states.header.applies_to"), empty_1()), headerCell(t("settings.inventory_states.header.allowed_actions"), empty_1()), headerCell(t("settings.inventory_states.header.usage"), empty_1()), headerCell("", empty_1())], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])))), reactElement("tbody", createObj(singleton_1((elems_2 = toList(delay(() => collect((matchValue) => {
        const index = matchValue[0] | 0;
        const definition_1 = matchValue[1];
        return singleton(createElement(StateRow, {
            Definition: definition_1,
            Dispatch: dispatch,
            FormState: formState,
            IsFirst: index === 0,
            IsLast: index === lastIndex,
            Usage: InventoryStatesDtoModule_usageOf(definition_1.Key, dto),
        }));
    }, indexed(states)))), ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function colorField(t, form, formState, state, pickerOpen, setPickerOpen, dispatch) {
    let elems_2;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_2 = toList(delay(() => append_1(singleton(reactElement("label", {
        className: join(" ", ["text-sm", "font-bold"]),
        children: t("settings.inventory_states.color"),
    })), delay(() => {
        let elems;
        return append_1(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-3"])], (elems = [createElement(Badge, {
            Color: form.Color,
            Label: (form.Name.trim() === "") ? form.Color : form.Name,
            TestId: "inventory-state-preview",
        }), createElement(Button, {
            ComponentState: state,
            Label: t("settings.inventory_states.choose_color"),
            OnClick: () => {
                setPickerOpen(!pickerOpen);
            },
            TestId: "inventory-state-choose-color",
            Variant: "secondary",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append_1(pickerOpen ? singleton(reactElement("div", createObj(ofArray([["data-test-id", "inventory-state-color-picker"], (elems_1 = [ColorPicker_colorPicker_BD3CF72((color) => {
                dispatch(new Msg(7, [color.hex]));
            }, form.Color)], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty(), delay(() => {
                const matchValue = FormState__getValidation(formState, t, "color");
                if (matchValue == null) {
                    return singleton(defaultOf());
                }
                else {
                    const message = matchValue;
                    return singleton(reactElement("div", {
                        className: join(" ", ["text-xs", "text-red"]),
                        children: message,
                    }));
                }
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function checkboxGroup(label, testId, hint, validation, children) {
    let elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], ["data-test-id", testId], (elems_1 = toList(delay(() => append_1(singleton(reactElement("label", {
        className: join(" ", ["text-sm", "font-bold"]),
        children: label,
    })), delay(() => {
        let matchValue;
        return append_1((matchValue = hint, (matchValue == null) ? singleton(defaultOf()) : singleton(matchValue)), delay(() => append_1(singleton(reactElement("div", {
            className: join(" ", ["grid", "grid-cols-2", "gap-x-6", "gap-y-2"]),
            children: reactApi.Children.toArray(Array.from(children)),
        })), delay(() => {
            const matchValue_1 = validation;
            if (matchValue_1 == null) {
                return singleton(defaultOf());
            }
            else {
                const message = matchValue_1;
                return singleton(reactElement("div", {
                    className: join(" ", ["text-xs", "text-red"]),
                    children: message,
                }));
            }
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function StateDialog(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const form = props.Form;
    const isSystem = FormModule_isSystem(form);
    const inUse = props.Usage > 0;
    const state = componentState(props.FormState);
    const definitionState = disabledIf(isSystem, state);
    const structureState = disabledIf(isSystem ? true : inUse, state);
    const allowedKinds = FormModule_kindsFor(form.BaseState);
    const baseStateOption = (baseState) => ({
        label: baseStateLabel(t, baseState),
        value: baseState,
    });
    const title = (form.Mode.tag === 1) ? t("settings.inventory_states.edit") : t("settings.inventory_states.create");
    return createElement(DialogWithClasses, {
        Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5", "w-[40rem]", "max-w-full"])], ["data-test-id", "inventory-state-dialog"], (elems_2 = toList(delay(() => {
            let arg_1;
            return append_1(isSystem ? singleton(createElement(InformationAlert, {
                Label: t("settings.inventory_states.system_hint"),
            })) : (inUse ? singleton(createElement(InformationAlert, {
                Label: (arg_1 = {
                    count: props.Usage,
                }, patternInput[1].t("settings.inventory_states.in_use_hint", arg_1)),
            })) : empty()), delay(() => append_1(singleton(createElement(Input, {
                ComponentState: definitionState,
                Label: t("settings.inventory_states.name"),
                OnChange: (arg_2) => {
                    props.Dispatch(new Msg(5, [arg_2]));
                },
                TestId: "inventory-state-name",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
                Value: form.Name,
            })), delay(() => append_1(singleton(createElement(TextArea, {
                ComponentState: state,
                Label: t("settings.inventory_states.description"),
                OnChange: (arg_3) => {
                    props.Dispatch(new Msg(6, [arg_3]));
                },
                TestId: "inventory-state-description",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "description")),
                Value: form.Description,
            })), delay(() => append_1(singleton(colorField(t, form, props.FormState, state, patternInput_1[0], patternInput_1[1], props.Dispatch)), delay(() => {
                let elems, Label_2, Options, Value_2;
                return append_1(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems = [createElement(Select, (Label_2 = t("settings.inventory_states.base_state_label"), (Options = map(baseStateOption, InventoryBaseStateModule_all), (Value_2 = baseStateOption(form.BaseState), {
                    ComponentState: structureState,
                    IsClearable: false,
                    Label: unwrap(Label_2),
                    NoOptionsMessage: "general.no_options",
                    OnChange: (selected) => {
                        if (selected == null) {
                        }
                        else {
                            props.Dispatch(new Msg(8, [selected.value]));
                        }
                    },
                    Options: Options,
                    PlaceholderKey: "settings.inventory_states.base_state_label",
                    TestId: "inventory-state-base-state",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "baseState")),
                    Value: unwrap(Value_2),
                })))), reactElement("div", {
                    className: join(" ", ["text-xs", "text-gray-500"]),
                    children: t("settings.inventory_states.base_state_hint"),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append_1(singleton(checkboxGroup(t("settings.inventory_states.applies_to"), "inventory-state-applies-to", undefined, FormState__getValidation(props.FormState, t, "appliesTo"), toList(delay(() => collect((kind) => {
                    let Label_3;
                    const selected_1 = contains(kind, form.AppliesTo, {
                        Equals: equals,
                        GetHashCode: (x) => (safeHash(x) | 0),
                    });
                    const allowed = contains(kind, allowedKinds, {
                        Equals: equals,
                        GetHashCode: (x_1) => (safeHash(x_1) | 0),
                    });
                    return singleton(Checkbox((Label_3 = t(InventoryKind__ToI18nString(kind)), {
                        ComponentState: disabledIf((isSystem ? true : !allowed) ? true : (inUse && selected_1), state),
                        IsChecked: selected_1,
                        Label: Label_3,
                        OnCheck: (checked$0027) => {
                            props.Dispatch(new Msg(9, [kind, checked$0027]));
                        },
                        TestId: concat("inventory-state-kind-", ...InventoryKind__get_Key(kind)),
                    })));
                }, InventoryKindModule_all))))), delay(() => {
                    let elems_1;
                    return append_1(singleton(checkboxGroup(t("settings.inventory_states.allowed_actions"), "inventory-state-allowed-actions", isSystem ? undefined : reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-4"])], (elems_1 = [createElement(TextButton, {
                        ComponentState: state,
                        Label: t("settings.inventory_states.select_all"),
                        OnClick: () => {
                            props.Dispatch(new Msg(11, [true]));
                        },
                        TestId: "inventory-state-select-all-actions",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: state,
                        Label: t("settings.inventory_states.deselect_all"),
                        OnClick: () => {
                            props.Dispatch(new Msg(11, [false]));
                        },
                        TestId: "inventory-state-deselect-all-actions",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), undefined, toList(delay(() => map_1((action) => Checkbox({
                        ComponentState: definitionState,
                        IsChecked: contains(action, form.AllowedActions, {
                            Equals: equals,
                            GetHashCode: (x_2) => (safeHash(x_2) | 0),
                        }),
                        Label: t(InventoryAction__ToI18nString(action)),
                        OnCheck: (checked$0027_1) => {
                            props.Dispatch(new Msg(10, [action, checked$0027_1]));
                        },
                        TestId: concat("inventory-state-action-", ...InventoryAction__get_Key(action)),
                    }), InventoryActionModule_all))))), delay(() => {
                        const matchValue_1 = FormState__getValidation(props.FormState, t, "global");
                        return (matchValue_1 == null) ? singleton(defaultOf()) : singleton(createElement(ErrorAlert, {
                            Label: matchValue_1,
                        }));
                    }));
                }))));
            }))))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))),
        Classes: empty_1(),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: state,
            Label: t("general.cancel"),
            OnClick: () => {
                props.Dispatch(new Msg(4, []));
            },
            TestId: "inventory-state-cancel",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: state,
            Label: t("general.save"),
            OnClick: () => {
                props.Dispatch(new Msg(12, []));
            },
            TestId: "inventory-state-save",
            Variant: "blueButton",
        })]),
        IsOpen: true,
        OnClose: () => {
            props.Dispatch(new Msg(4, []));
        },
        Title: title,
    });
}

function LoadFailed(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], ["data-test-id", "inventory-states-load-failed"], (elems_1 = [createElement(ErrorAlert, {
        Label: t("settings.inventory_states.load_failed"),
    }), reactElement("div", createObj(singleton_1((elems = [createElement(Button, {
        ComponentState: "enabled",
        Label: t("settings.inventory_states.reload"),
        OnClick: () => {
            props.Dispatch(new Msg(1, []));
        },
        TestId: "inventory-states-reload-button",
        Variant: "secondary",
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function InventoryStatesSettings() {
    let elems_1;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const matchValue = state_1.States;
    if (matchValue.tag === 1) {
        const dto = matchValue.fields[0];
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], ["data-test-id", "inventory-states-settings"], (elems_1 = toList(delay(() => append_1(singleton(reactElement("div", {
            className: join(" ", ["text-sm"]),
            children: t("settings.inventory_states.description_text"),
        })), delay(() => {
            let elems, Label;
            return append_1(singleton(reactElement("div", createObj(singleton_1((elems = [createElement(Button, (Label = t("settings.inventory_states.create"), {
                ComponentState: componentState(state_1.FormState),
                Label: Label,
                OnClick: () => {
                    dispatch(new Msg(2, []));
                },
                TestId: "inventory-states-create-button",
                Variant: "primary",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))]))))), delay(() => append_1(singleton(statesTable(t, dto, state_1.FormState, dispatch)), delay(() => {
                let matchValue_1, form;
                return append_1((matchValue_1 = state_1.Form, (matchValue_1 == null) ? singleton(defaultOf()) : ((form = matchValue_1, singleton(createElement(StateDialog, {
                    Dispatch: dispatch,
                    Form: form,
                    FormState: state_1.FormState,
                    Usage: defaultArg(map_2((definition) => (InventoryStatesDtoModule_usageOf(definition.Key, dto) | 0), FormModule_current(form)), 0),
                }))))), delay(() => {
                    let Title, arg_1;
                    const matchValue_2 = state_1.PendingDelete;
                    if (matchValue_2 == null) {
                        return singleton(defaultOf());
                    }
                    else {
                        const definition_1 = matchValue_2;
                        return singleton(createElement(ConfirmationDialog, (Title = t("settings.inventory_states.delete_title"), {
                            Description: (arg_1 = {
                                name: definition_1.Name,
                            }, patternInput[1].t("settings.inventory_states.delete_description", arg_1)),
                            FormState: state_1.FormState,
                            IsOpen: true,
                            OnClose: () => {
                                dispatch(new Msg(20, []));
                            },
                            OnConfirm: () => {
                                dispatch(new Msg(21, []));
                            },
                            Title: Title,
                        })));
                    }
                }));
            }))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
    else if (state_1.LoadFailed) {
        return createElement(LoadFailed, {
            Dispatch: dispatch,
        });
    }
    else {
        return defaultOf();
    }
}

